window.SmoothScrollOptions = {
    animationTime       : 1500,
    accelerationDelta   : 50,
    accelerationMax     : 1
}
require('../../node_modules/smoothscroll-for-websites/SmoothScroll');
require("fslightbox");

if($('[data-fslightbox]').length > 0){
    fsLightbox.props.type = "image";
}

// require('../../node_modules/simplelightbox/dist/simple-lightbox.min.js');

import { gsap }                 from "gsap";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import * as Menu                from "./components/Menu";
// import * as Search              from "./components/Search";


import AjaxLoadPage             from "./components/AjaxLoadPage";
import PaginationAjax           from "./components/PaginationAjax";
import ScrollEvents             from "./components/ScrollEvents";
import SwiperGalleries          from './components/SwiperGallery';
import offCanvas                from './components/offCanvas';
// import SimpleLightbox           from "./components/SimpleLightBox";
// import * as Intros              from "./components/IntroPage";
import * as mask                from "./components/jqMask";
import * as jqValidate          from "./components/JqValidate";
// import * as Gallery             from "./components/Gallery";
import * as Svg                 from "./components/Svg";
import * as ModalVideo          from "./components/ModalVideo";
import * as FormAjax 			from "./components/FormAjax";
import * as CustomDropdown		from "./components/CustomDropdown";
import * as CustomSwitch        from "./components/Switch";


// loader site
document.onreadystatechange = function () {
    //AjaxLoadPage.init(1);
    jqValidate.formAjax();
    if (document.readyState == "complete") {
        app();
    }
}

const app = () => {
    AjaxLoadPage.init(0);
    PaginationAjax.init();
    Menu.init();
    update();
}

window.update = () =>{
    // Search.init();
    // Intros.init();
    mask.inputsMask();
    FormAjax.init();
    ScrollEvents.init();
    CustomDropdown.init();
    CustomSwitch.init();
    SwiperGalleries.init();
    jqValidate.formAjax();
    ModalVideo.init();
    // SimpleLightbox.init();
    offCanvas.init();
    setTimeout(()=>{
        Svg.init();
		checkLinksToExternal();
    },500);


    // percorre links da página e se não forem do dominio led, deixo como target "_blank"
	function checkLinksToExternal (){
		const dominiosLed = [
			'localhost',
			'127.0.0.1',
			'workwithone.com',
			'ledforum.workwithone.com',
			'ledforum.com.br'
		];
		document.querySelectorAll('a[href]').forEach(link => {
			try {
				const linkUrl = new URL(link.href, window.location.href);
				const dominioDoLink = linkUrl.hostname;

				const isDominioExterno = dominiosLed.some(dominio => 
					dominioDoLink.endsWith(dominio)
				);

				if (!isDominioExterno) {
					link.setAttribute('target', '_blank');
					link.setAttribute('rel', 'noopener noreferrer');
				}
			} catch (e) {
			console.warn('URL inválida:', link.href);
			}
		});
	}

}
